export default __webpack_public_path__ + "static/media/465.8af8da20.png";